$(document).ready(function() {

	$("#slcProcUser").select2();
	$("#slcUserChange").select2();

	$(document).on("change", "#liberateBillingConcept", function() {
		$('#exampleModalLong').modal('show');
	});

	$('#select-all').click(function(event) {
		if(this.checked) {
			// Iterate each checkbox
			$(':checkbox').each(function() {
				this.checked = true;
			});
		} else {
			$(':checkbox').each(function() {
				this.checked = false;
			});
		}
	});

	$('[data-toggle="tooltip"]').tooltip();

	$(document).on("click", ".open-accountclient", function() {
		var isClosed = $(this).hasClass("closed");
		if (isClosed) {
			$("span", this).html($("span", this).html().replace("Expandir", "Esconder"));
			$("i", this).addClass("fa-minus");
			$("#allData a, #finnancial a").attr("aria-expanded", true).attr("class", "");
			$("#collapseAllData, #collapseFinancial, #collapseHistorico").attr("aria-expanded", true).attr("class", "panel-collapse collapse show");
			$(this).removeClass("closed").addClass("opened");
		} else {
			$("span", this).html($("span", this).html().replace("Esconder", "Expandir"));
			$("i", this).removeClass("fa-minus");
			$("#allData a, #finnancial a").attr("aria-expanded", false).attr("class", "collapsed");
			$("#collapseAllData, #collapseFinancial, #collapseHistorico").attr("aria-expanded", false).attr("class", "panel-collapse collapse");		
			$(this).removeClass("opened").addClass("closed");
		}
	});
});



// WEBPACK FOOTER //
// src/assets/scripts/main.js